<div class="wrapper">
  <div class="header flex justify-between items-center">
    @if (!isSearchActive) {
      <div class="heading text-type-1">Projects</div>

      <div class="flex items-center gap-[12px]">
        @if (projects?.length > 5) {
          <div class="search-wrapper" (click)="onSearchClick($event)">
            <mat-icon class="search-icon-inline">search</mat-icon>
            <span class="search-placeholder">Search</span>
          </div>
        }

        <div
          [matMenuTriggerFor]="menu"
          class="menu-button text-type-8 flex gap-[20px]"
        >
          <div>{{ frequency }}</div>
          <mat-icon class="menu-icon" svgIcon="chevron-down" />
        </div>

        <mat-menu #menu="matMenu">
          <button (click)="setFrequency('All')" mat-menu-item>All</button>
          <button (click)="setFrequency('Recently updated')" mat-menu-item>Recently updated</button>
          @if (expiringWarrantyCount > 0) {
            <button (click)="setFrequency('Expiring warranty')" mat-menu-item>Expiring warranty</button>
          }
        </mat-menu>
      </div>
    } @else {
      <div class="search-wrapper expanded">
        <mat-icon class="search-icon-inline">search</mat-icon>
        <input
          #searchInputEl
          (input)="onSearch($event.target.value)"
          [value]="searchQuery"
          class="search-input-inline"
          placeholder="Search by project name or number..."
          type="text"
        />
        <button (click)="clearSearch()" class="clear-search-inline" mat-icon-button>
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    }
  </div>

  @if (showReviewQueue) {
    <div class="review-queue-strip" (click)="openReviewQueue()" data-testid="review-queue-strip">
      <span class="review-queue-count">{{ reviewQueue.total_waiting }}</span>
      <span>
        {{ reviewQueue.total_waiting === 1 ? 'report' : 'reports' }} awaiting your approval
        · {{ reviewQueue.total_projects }} {{ reviewQueue.total_projects === 1 ? 'project' : 'projects' }}
      </span>
      <span class="review-queue-link">Review queue <mat-icon svgIcon="chevron-right" /></span>
    </div>
  }

  @if (expiringWarrantyCount > 0 && frequency !== 'Expiring warranty') {
    <div class="warranty-alert" (click)="setFrequency('Expiring warranty')">
      <mat-icon class="warranty-alert-icon">warning_amber</mat-icon>
      <span>{{ expiringWarrantyCount }} {{ expiringWarrantyCount === 1 ? 'project has' : 'projects have' }} expiring warranty</span>
    </div>
  }

  <!-- Project List Section -->
  @if (!isLoading) {
    <div class="project-list-section">
      @if (paginatedFilteredProjects?.length) {
        @for (project of paginatedFilteredProjects; track project; let lastItem = $last) {
          <ng-container
            class="each-project"
            >
            <app-projects-page-each-project-card
              [project]="project"
              [showProgress]="true"
              class="project-card"
              picHeight="150px"
              />
            @if (!lastItem) {
              <hr class="hr-line" />
            }
          </ng-container>
        }
      } @else {
        <div class="no-data">
          There are no projects available for your selection.
        </div>
      }
    </div>
  }
  <app-paginator
    (pageChanged)="onPageChanged($event)"
    [itemsPerPage]="itemsPerPage"
    [totalItems]="filteredProjects.length"
    class="paginator"
    >
  </app-paginator>
</div>
